import React from "react";

import { CeoMessage } from "./versions/CeoMessage";
import { CertipurUs } from "./versions/CertipurUs";
import { CompareAdapt } from "./versions/CompareAdapt";
import { CompareAdapt2 } from "./versions/CompareAdapt2";
import { CompareBreeze } from "./versions/CompareBreeze";
import { CompareBreeze2 } from "./versions/CompareBreeze2";
import { GrayTestimonials } from "./versions/GrayTestimonials";
import {
    JdPower2022BannerDouble,
    JdPower2022BannerDoubleV2,
    JdPower2022BannerMultiple,
} from "./versions/JdPower2022Banners";
import {
    JdPower2022BlockDark,
    JdPower2022BlockInStoreDark,
    JdPower2022BlockInStoreLight,
    JdPower2022BlockLight,
} from "./versions/JdPower2022Blocks";
import { JdPower2023BannerTriple } from "./versions/JdPower2023";
import {
    JdPower2024BannerCenteredWithYears,
    JdPower2024BannerFirstVersion,
    JdPower2024BannerQuadruple,
} from "./versions/JdPower2024";
import { OrientTestimonials } from "./versions/OrientTestimonials";
import { SocialBanner } from "./versions/SocialBanner";

/**
 * Per-version React component registry for ``HardcodedBlockTemplate`` (#33404).
 *
 * Each entry is keyed by the full ``hc-block--<name>`` version string (the raw
 * ``version`` field value). The dispatcher in ``HardcodedBlockTemplate`` looks
 * the version up here: a hit renders the native React component inside the
 * ``<section class="hc-block ...">`` wrapper; a miss renders ``null`` (matching
 * the legacy ``{% file_exists %}`` else-branch, which emitted only an HTML
 * comment). ALL non-prequal versions now render natively here -- there is no
 * server-rendered ``html`` fallback anymore (#33404 part 2). The
 * ``hc-block--prequal-card`` interactive island stays a dedicated branch in the
 * dispatcher and is deliberately NOT registered here.
 *
 * Each component returns the partial's inner markup as a fragment (the wrapper
 * ``<section>`` is supplied by the dispatcher), exactly reproducing the legacy
 * Django partial DOM so the existing CSS/JS keep working.
 */
export const VERSION_COMPONENTS: Readonly<
    Partial<Record<string, () => React.JSX.Element>>
> = {
    "hc-block--certipur-us": CertipurUs,
    "hc-block--ceo-message": CeoMessage,
    "hc-block--compare-adapt": CompareAdapt,
    "hc-block--compare-adapt-2": CompareAdapt2,
    "hc-block--compare-breeze": CompareBreeze,
    "hc-block--compare-breeze-2": CompareBreeze2,
    "hc-block--social-banner": SocialBanner,
    "hc-block--gray-testimonials": GrayTestimonials,
    "hc-block--orient-testimonials": OrientTestimonials,
    "hc-block--jdpower-2023--banner-triple": JdPower2023BannerTriple,
    "hc-block--jdpower-2024--banner-centered-with-years":
        JdPower2024BannerCenteredWithYears,
    "hc-block--jdpower-2024--banner-first-version":
        JdPower2024BannerFirstVersion,
    "hc-block--jdpower-2024--banner-quadruple": JdPower2024BannerQuadruple,
    "hc-block--jdpower-2022--banner-double-v2": JdPower2022BannerDoubleV2,
    "hc-block--jdpower-2022--banner-double": JdPower2022BannerDouble,
    "hc-block--jdpower-2022--banner-multiple": JdPower2022BannerMultiple,
    "hc-block--jdpower-2022--block-dark": JdPower2022BlockDark,
    "hc-block--jdpower-2022--block-in-store-dark": JdPower2022BlockInStoreDark,
    "hc-block--jdpower-2022--block-in-store-light":
        JdPower2022BlockInStoreLight,
    "hc-block--jdpower-2022--block-light": JdPower2022BlockLight,
};
